import React from 'react';
import { ProductResponse } from '@/api/bol';
import { DeleteConfirmDialog } from '@/components/common/DeleteConfirmDialog';

export interface ProductDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  product: ProductResponse | null;
}

export const ProductDeleteDialog: React.FC<ProductDeleteDialogProps> = ({
  open,
  onClose,
  onConfirm,
  product,
}) => {
  return (
    <DeleteConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      itemType="product"
      itemId={product?.id || ''}
    />
  );
};
